import { Alpine } from "alpinejs";
import { v4 as uuidv4 } from 'uuid';

const NO_FOUND_EL_ERROR_MSG = "Please enter a valid address in South Australia."
const SA_BOUNDS = {
	"south": -38.0659,
	"west": 129.0000,
	"north": -25.9960,
	"east": 141.0028
};
function membersApp({
    tab,
    sort,
    electorateQuery
  }) {
    return {
        loading:false,
        tab: tab,
        sort: sort,
        electorateQuery:electorateQuery,
        address: Alpine.store('global')?.address ??  '',
        lat: Alpine.store('global')?.lat ??  '',
        lng: Alpine.store('global')?.lng ??  '',
        foundaddress:false,
        error:false,
        errorMsg:'',
        reload: false,
       async init() {
            const url = new URL(window.location);
            if(!url.searchParams.has('electorate') && Alpine.store('global')?.electorate != ''){
                // set electotrate params
                url.searchParams.set('electorate',Alpine.store('global')?.electorate);
                window.history.pushState({}, '', url);
                // fetch entries
                this.sort = null; // default sort
                this.tab = 'all'; // default tab
                this.electorateQuery = Alpine.store('global')?.electorate;
                await this.fetchEntries(true);
            }else{
              // Inital Fetch
              await this.fetchEntries(false);
            }

            // Clear if does not match with store
            if(url.searchParams.has('electorate') && Alpine.store('global')?.electorate != ''){
                if(url.searchParams.get('electorate') != Alpine.store('global')?.electorate != ''){
                    this.address = '';
                    this.lat = '';
                    this.lng = '';
                    this.$refs.listingaddress.value = ''
                    Alpine.store('global').clearAddress('');
                }
            }
        
            // Address Init
            await this.addressinit();

            // Watch for address changes
            this.$watch("Alpine.store('global')?.address", async (address) => {
                if(address != ''){
                    let searchParams = new URLSearchParams(window.location.search);
                    if(searchParams.has('electorate')){
                        this.sort = null; // default sort
                        this.tab = 'all'; // default tab
                        this.electorateQuery = searchParams.get('electorate');
                        await this.fetchEntries(true);
                    }
                }
            })
        },
        async resetFilter(){
            const url = new URL(window.location);
            if(url.searchParams.has('electorate')){
                url.searchParams.delete('electorate');
                window.history.pushState({}, '', url);
                this.electorateQuery = '';
                this.sort = '';
                await this.fetchEntries(true);
            }
        },
        async  addressinit() {
            const sessionToken =  uuidv4(); // generate session token
            await this.initializeAutocomplete();
            if(Alpine.store("global")?.address != ''){
                this.foundaddress = true
            }
            this.$watch("Alpine.store('global')?.address", async (address) => {
                if(address != ''){
                   this.address =  address;
                }
             })
        },
        async  initializeAutocomplete() {
                    await google.maps.importLibrary("places");
                    // Get the input element
                    const input = document.getElementById("customautocomplete");
                    if (!input) {
                        return;
                    }
                    // Initialize Autocomplete on the input element
                    const autocomplete = new google.maps.places.Autocomplete(input, {
                        types: ["street_address" ,"administrative_area_level_1" ,  "sublocality", "locality", "postal_code"], 
                        bounds: SA_BOUNDS,
                        strictBounds: true,
                        componentRestrictions:  { country: "au" },
                    });
                    // Add listener for place selection
                    autocomplete.addListener("place_changed", () => {
                        try {
                            const place = autocomplete.getPlace();
                            if (!place.place_id) {
                                this.error  = true;
                                this.errorMsg = NO_FOUND_EL_ERROR_MSG
                                return;
                            }

                           const placeLatLng = place.geometry?.location?.toJSON()
                            if(placeLatLng.lat && placeLatLng.lng){
                                this.address = place.formatted_address;
                                this.lat = placeLatLng.lat;
                                this.lng =  placeLatLng.lng;
                                // clear
                                this.foundaddress = true;
                                this.error = false;
                                // Run submit
                                this.handleSubmit();
                            }else{
                                if(foundaddressOverride == false ){
                                    this.error  = true;
                                    this.errorMsg = NO_FOUND_EL_ERROR_MSG
                                    return;
                                } 
                                this.handleSubmit();
                            }
                        } catch (error) {
                                this.error  = true;
                                this.errorMsg = NO_FOUND_EL_ERROR_MSG
                        }
                    });
                    input.addEventListener('input',(e)=>{
                        if(e.target.value == ''){
                                this.error = false;
                                this.errorMsg = "";
                                this.foundaddress = false;
                                this.lat = '';
                                this.lng = '';
                                Alpine.store('global').clearAddress('');
                        }
                        if (e.target !== e.currentTarget) return;
                        let value = e.target.value;
                        if(!value){
                            this.foundaddress = false;
                            this.address = '';
                            this.lat = '';
                            this.lng = '';
                            Alpine.store('global').clearAddress('');
                            this.resetFilter();
                            return;
                        }
                        if(Alpine.store("global")?.address != '' && value && value?.trim() != Alpine.store("global")?.address?.trim()){
                                this.foundaddress = false;
                                this.lat = '';
                                this.lng = '';
                                Alpine.store('global').clearAddress('');
                        }
                    })
        },
        async handleclear(){
            this.loading = false; // add loading to false on clear
            this.foundaddress = false;
            this.address = '';
            this.lat = '';
            this.lng = '';
            Alpine.store('global').clearAddress('');
            this.resetFilter();
            return;
        },
        async clearGloablForm(){
            this.address = '';
            this.lat = '';
            this.lng = '';
            let url = new URL(window.location);
            if(url.searchParams.has('electorate')){
                url.searchParams.delete('electorate');
            }
            window.history.pushState({}, '', url);
            Alpine.store('global').clearAddress('');
        },
        async handleButtonSubmitClick(){
            if(this.foundaddress == false){
                this.error = true;
                this.errorMsg = NO_FOUND_EL_ERROR_MSG
                return;
            }
            await this.handleSubmit();
        },
        async handleSubmit() {
            let searchparams = new URLSearchParams();
            try {
                if(this.lat != '' && this.lng != '' && this.address != ''){
                    const res = await fetch(`api/members?lat=${encodeURIComponent(this.lat)}&lng=${encodeURIComponent(this.lng)}`).then(res=> res.json())
                    if(res?.data?.name){
                        let url = new URL(window.location);
                        url.searchParams.set('electorate',res?.data?.name);
                        url.searchParams.delete('sort'); // remove sort
                        url.searchParams.delete('tab'); // remove tab
                        window.history.pushState({}, '', url);
                        // Update Global State
                        Alpine.store('global').setAddress(this.address);
                        Alpine.store('global').setLat(this.lat);
                        Alpine.store('global').setLng(this.lng);
                        Alpine.store('global').setElectorate(res?.data?.name);
                        // Remove Eror
                         this.error  = false;
                         this.errorMsg = null;
                    }else{
                        this.clearGloablForm()
                    }
                }
            } catch (error) {
                 this.error  = true;
                 this.errorMsg = NO_FOUND_EL_ERROR_MSG
            }
        },
        async handleSort(value){
                this.sort = value;
                const url = new URL(window.location);
                if (value) {
                    // Reset input
                    // this.$refs.listingaddress.value = '';
                    this.error = false;
                    this.errorMsg = '';
                    // Set params 
                    url.searchParams.set('sort', value);
                    // url.searchParams.delete('electorate'); // remove electorate
                    // this.electorateQuery = ''; // remove electorate
                    // Alpine.store('global').clearAddress(); // clear addrees
                } else {
                    url.searchParams.delete('sort');
                }

                window.history.pushState({}, '', url);

                await this.fetchEntries(true);
        },
        async handleTab(value){
                if(this.tab === value) return; // return if same
                this.tab = value;
                const url = new URL(window.location);
                if (value) {
                    // Reset input
                    this.error = false;
                    this.errorMsg = '';
                    // Set params 
                    url.searchParams.set('tab', value);
                } else {
                    url.searchParams.delete('tab');
                }
                window.history.pushState({}, '', url);
                await this.fetchEntries(true);
        },
        async loadMore() {
            // await this.fetchEntries();
            // this.offset += this.limit;
        },
        async fetchEntries(replace = false) {
           try {
             if(this.loading)  return;
             this.loading = true;
             const url = '/actions/simpleModule/members/index?' + new URLSearchParams({
                tab: this.tab,
                sort: this.sort,
                electorateQuery: this.electorateQuery
            });

            const response = await fetch(url, {
                headers: { 'Accept': 'application/json' },
            });
            const data = await response.json();

            if (replace) {
                this.$refs.results.innerHTML = data.data;
            } 
            else {
                this.$refs.results.insertAdjacentHTML('beforeend', data.data);
            }
           } catch (error) {
           }finally{
               this.loading = false;
           }
        }
    }
}

document.addEventListener("alpine:init", () => {
    Alpine.data("membersApp", membersApp)
})